<template>
    <svg width="26" height="33" viewBox="0 0 26 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19 6.5c0 4.59-3.69 6.5-6 6.5s-6-1.91-6-6.5S8.69 0 13 0c4.31 0 6 1.91 6 6.5zM25.86 29.43c0 6.31-5.76 5.71-12.86 5.71S.14 35.74.14 29.43s2.62-15 12.86-15c10.24 0 12.86 8.69 12.86 15z"
            fill="#fff"
        />
    </svg>
</template>
